import React, { useEffect } from "react";
import Category from '../../components/Category/Category'
import Homeproduct from '../../components/HomeProductCard/Homeproduct'
import "./Home.css"
import "aos/dist/aos.css";
import AOS from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ReviewSection from "../../components/reviews/Review";
import LastVisitedProduct from "../../components/lastVisitedpage/LastVisitedProduct";
import Blog from "../../components/blog/Blog";
import WhyChoose from "../../components/whyChooseUs/WhyChoose";


const Home = () => {

  
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  
 
  const data = [
    { imgUrl: "/images/banner.webp" },
    { imgUrl: "/images/banner3.jpg" },
    { imgUrl: "/images/banner3.jpeg" },
    { imgUrl: "/images/banner4.jpeg" },
    { imgUrl: "/images/banner5.jpeg" },
    { imgUrl: "/images/banner6.jpeg" },
    { imgUrl: "/images/banner7.jpg" },



  ];

  return (
    <div className="">
     

      {/* Single Success Story Slider */}
      <div className="container mx-auto py-8 px-4 sm:px-0">
        <Swiper
          modules={[Autoplay, Navigation]}
          autoplay={{ delay: 3000 }}
          // navigation
          loop={true}
          className="w-full  rounded-lg shadow-lg"
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <img
                src={item.imgUrl}
                alt={`Slide ${index + 1}`}
                className="md:w-full md:h-[350px] h-[480px] object-cover rounded-lg"
                loading="lazy"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    
      <Homeproduct />
      <LastVisitedProduct/>

     <Blog/>

           <WhyChoose/>
     

<div>
</div>

      <ReviewSection />
    </div>
  );
};

export default Home;